import { render } from "./ModalComponent.vue?vue&type=template&id=1fedae00&scoped=true&ts=true"
import script from "./ModalComponent.vue?vue&type=script&lang=ts"
export * from "./ModalComponent.vue?vue&type=script&lang=ts"

import "./ModalComponent.vue?vue&type=style&index=0&id=1fedae00&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Documents\\Repos\\PROD-license-management\\redesign\\WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fedae00"]])

export default __exports__